import type { AdminOrderDetail, UpdateOrderStatusRequest } from '../../domain/entities/AdminOrder';
import type { OrderRepository } from '../../domain/repositories/OrderRepository';

export class UpdateOrderStatusUseCase {
  constructor(private readonly repository: OrderRepository) {}

  async execute(orderId: string, data: UpdateOrderStatusRequest): Promise<AdminOrderDetail> {
    return this.repository.updateOrderStatus(orderId, data);
  }
}
